import React, { useEffect, useState, useContext } from 'react'
import moment from 'moment'
import { Avatar, Box, Card, CardContent, Typography } from '@material-ui/core'

import { getPublicAPI } from '../../api'

const UserProfile = props => {
   let customerId = props?.customerid
   const [values, setValues] = useState({
      avatar: '',
      email: '',
      name: ''
   })

   useEffect(() => {
      async function getUserData() {
         let userData = await getPublicAPI(`/user/${customerId}`)
         if (userData?.success) {
            setValues({
               name: userData.data.fName + ' ' + userData.data.lName,
               email: userData.data.email,
               avatar: userData.picture.picture
            })
         }
      }
      getUserData()
   }, [customerId])

   return (
      <Card {...props}>
         <CardContent>
            <Box
               sx={{
                  alignItems: 'center',
                  display: 'flex',
                  flexDirection: 'column'
               }}
            >
               <Avatar
                  src={values.avatar}
                  sx={{
                     height: 100,
                     width: 100
                  }}
               />
               <Typography color='textPrimary' gutterBottom variant='h3'>
                  {values.name}
               </Typography>

               <Typography color='textSecondary' variant='body1'>
                  {values.email}
               </Typography>

               <Typography color='textSecondary' variant='body1'>
                  {`${moment().format('hh:mm A')}`}
               </Typography>
            </Box>
         </CardContent>
      </Card>
   )
}

export default UserProfile
